import { useAATheme } from "./AAThemeContext";
import { getColorsForDataset } from "./constants";

const modelColorMap: {
  [key: string]: { borderColor: string; backgroundColor: string };
} = {};
let nextColorIndex = 0;

export type ModelColorMap = {
  getColors: (modelName: string) => {
    borderColor: string;
    backgroundColor: string;
  };
};

const useModelColorMap = (): ModelColorMap => {
  const { isDarkMode } = useAATheme();
  const getColors = (
    modelName: string
  ): { borderColor: string; backgroundColor: string } => {
    let modelColor = modelColorMap[modelName];
    if (!modelColor) {
      const { borderColor, backgroundColor } = getColorsForDataset(
        nextColorIndex,
        isDarkMode
      );
      modelColor = { borderColor, backgroundColor };
      modelColorMap[modelName] = modelColor;

      nextColorIndex++;
    }

    return { ...modelColor! };
  };

  return { getColors };
};

export default useModelColorMap;
